import type { JSX } from 'react';

interface LoadingScreenProps {
  message?: string;
}

// Full-page centered loading state. Used by AdminGate during auth + role
// resolution and during cross-subdomain redirects. Mirrors arbi root's
// AuthGuard loading shell visually so the cross-app transition is seamless.
export default function LoadingScreen({ message }: LoadingScreenProps): JSX.Element {
  return (
    <div className="min-h-screen bg-surface-0 flex items-center justify-center">
      <div className="text-ink-muted text-sm">{message ?? 'Loading…'}</div>
    </div>
  );
}
